import React, { Component } from 'react';
import { observer } from 'mobx-react';

import store from '../store/store.js'

import Lightbox from 'react-image-lightbox';
import FlatButton from 'material-ui/FlatButton';
import ActionPrint from 'material-ui/svg-icons/action/print';
import ActionGetApp from 'material-ui/svg-icons/action/get-app';

const LightBoxMob = observer( (props) => {
  
  function prnWindow (_url, _name, _width, _height) {
    
    let nw = window.open(_url, _name, 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=no, width=' + _width + ', height=' + _height + '');
    //setTimeout( () => nw.print(), 500);
    nw.print();
    // let ans = nw.confirm("Распечатать эту заявку?");
    // if (ans==true) nw.print();
  }


  const SaveButton = () => {
    return (<a href={store.lb.imgUrl} download>
              <FlatButton
                label = "Сохранить"
                icon = {<ActionGetApp color="black" />}
                style = {{backgroundColor: "white", marginRight: 20}}
              />
            </a>)
  }

  const PrintButton = () => {
    return (<FlatButton 
              label = "Печать"
              icon = {<ActionPrint color="black" />}
              style = {{backgroundColor: "white", marginRight: 20}}
              onClick = { () => window.print() } //prnWindow(props.imageUrl,'Заказ','1366','768') }
              /> 
    )
  }

  let Lb = <div />;
  if (store.lb.isOpen) {
    Lb = <Lightbox
              reactModalStyle = {{overlay: {zIndex: 1500} }}
              mainSrc={store.lb.imgUrl}
              onCloseRequest={() => store.hideLightBox()}
              toolbarButtons={[<SaveButton/>,<PrintButton/>]}
          />
  } 

  return Lb;
  
} );

export default LightBoxMob;


// WEBPACK FOOTER //
// ./src/coms/LightBoxMob.jsx